import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const Orders = lazy(() => import('../components/sales/Orders'));
const OrderDetailPage = lazy(() => import('../components/sales/OrderDetailPage'));
const WholesalePageWrapper = lazy(() => import('../components/wholesale/WholesalePageWrapper'));

export const salesRoutes = (
  <>
    <Route
      path="/sales"
      element={
        <WholesalePageWrapper noHeader wide>
          <Orders />
        </WholesalePageWrapper>
      }
    />
    <Route
      path="/sales/:orderId"
      element={
        <WholesalePageWrapper noHeader wide>
          <OrderDetailPage />
        </WholesalePageWrapper>
      }
    />
  </>
);
